import * as PlatformStyle from './PlatformStyle';
import * as Token from './Token';
import * as ThemeDefault from './ThemeDefault';
// need to refactor this
const buttonContainerStyle = {
    paddingVertical: Token.spacing.xs,
    paddingHorizontal: Token.spacing.s,
    borderRadius: Token.border.radius.default,
};
// need to refactor this
const buttonTextStyle = Object.assign({ textAlign: 'center' }, PlatformStyle.textWeightMediumStyle);
// need to refactor this
export function createStyles(themeColor = ThemeDefault.color) {
    return {
        // DRNButton
        buttonTextStyle: {
            small: {
                fontSize: Token.fontSize.small,
                lineHeight: 16,
            },
            medium: {
                fontSize: Token.fontSize.medium,
                lineHeight: 24,
            },
            large: {
                fontSize: Token.fontSize.large,
                lineHeight: 32,
            },
        },
        buttonPrimary: {
            buttonColors: ThemeDefault.buttonBgColorPrimary,
            containerStyle: buttonContainerStyle,
            textColors: ThemeDefault.buttonTextColorPrimary,
            textStyle: buttonTextStyle,
            borderColors: ThemeDefault.buttonTransparentColor,
        },
        buttonMainCta: {
            buttonColors: ThemeDefault.buttonBgColorMainCta,
            containerStyle: buttonContainerStyle,
            textColors: ThemeDefault.buttonTextColorMainCta,
            textStyle: buttonTextStyle,
            borderColors: ThemeDefault.buttonTransparentColor,
        },
        buttonSecondary: {
            buttonColors: ThemeDefault.buttonBgColorSecondary,
            containerStyle: buttonContainerStyle,
            textColors: ThemeDefault.buttonTextColorSecondary,
            textStyle: buttonTextStyle,
            borderColors: ThemeDefault.buttonTransparentColor,
        },
        buttonText: {
            buttonColors: ThemeDefault.buttonTransparentColor,
            containerStyle: Object.assign({}, buttonContainerStyle, { borderRadius: 0, paddingHorizontal: 0 }),
            textColors: ThemeDefault.buttonTextColorText,
            textStyle: Object.assign({}, buttonTextStyle),
            borderColors: ThemeDefault.buttonTransparentColor,
        },
        buttonTextBlack: {
            buttonColors: ThemeDefault.buttonTransparentColor,
            containerStyle: Object.assign({}, buttonContainerStyle, { borderRadius: 0, paddingHorizontal: 0 }),
            textColors: ThemeDefault.buttonTextColorTextBlack,
            textStyle: Object.assign({}, buttonTextStyle),
            borderColors: ThemeDefault.buttonTransparentColor,
        },
        buttonTextWhite: {
            buttonColors: ThemeDefault.buttonTransparentColor,
            containerStyle: Object.assign({}, buttonContainerStyle, { borderRadius: 0, paddingHorizontal: 0 }),
            textColors: ThemeDefault.buttonTextColorTextWhite,
            textStyle: Object.assign({}, buttonTextStyle),
            borderColors: ThemeDefault.buttonTransparentColor,
        },
        buttonTextDestructive: {
            buttonColors: ThemeDefault.buttonTransparentColor,
            containerStyle: Object.assign({}, buttonContainerStyle, { borderRadius: 0, paddingHorizontal: 0 }),
            textColors: ThemeDefault.buttonTextColorTextDestructive,
            textStyle: Object.assign({}, buttonTextStyle),
            borderColors: ThemeDefault.buttonTransparentColor,
        },
        buttonOutlineBlack: {
            buttonColors: ThemeDefault.buttonTransparentColor,
            containerStyle: Object.assign({}, buttonContainerStyle, { paddingVertical: Token.spacing.xs - 1, paddingHorizontal: Token.spacing.s - 1, borderWidth: 1 }),
            textColors: ThemeDefault.buttonTextOutlineBlack,
            textStyle: buttonTextStyle,
            borderColors: ThemeDefault.buttonBorderOutlineBlack,
        },
        buttonOutlineWhite: {
            buttonColors: ThemeDefault.buttonTransparentColor,
            containerStyle: Object.assign({}, buttonContainerStyle, { paddingVertical: Token.spacing.xs - 1, paddingHorizontal: Token.spacing.s - 1, borderWidth: 1 }),
            textColors: ThemeDefault.buttonTextOutlineWhite,
            textStyle: buttonTextStyle,
            borderColors: ThemeDefault.buttonBorderOutlineWhite,
        },
        buttonDestructivePrimary: {
            buttonColors: ThemeDefault.buttonBgColorDestructivePrimary,
            containerStyle: buttonContainerStyle,
            textColors: ThemeDefault.buttonTextColorDestructivePrimary,
            textStyle: buttonTextStyle,
            borderColors: ThemeDefault.buttonTransparentColor,
        },
        buttonDestructiveSecondary: {
            buttonColors: ThemeDefault.buttonBgColorDestructiveSecondary,
            containerStyle: buttonContainerStyle,
            textColors: ThemeDefault.buttonTextColorDestructiveSecondary,
            textStyle: buttonTextStyle,
            borderColors: ThemeDefault.buttonTransparentColor,
        },
        buttonCircularPrimary: {
            buttonColors: ThemeDefault.buttonBgColorPrimary,
            containerStyle: Object.assign({}, buttonContainerStyle, PlatformStyle.elevation.hover, { borderRadius: 24 }),
            textColors: ThemeDefault.buttonTextColorPrimary,
            textStyle: buttonTextStyle,
            borderColors: ThemeDefault.buttonTransparentColor,
        },
        buttonCircularMainCta: {
            buttonColors: ThemeDefault.buttonBgColorMainCta,
            containerStyle: Object.assign({}, buttonContainerStyle, PlatformStyle.elevation.hover, { borderRadius: 24 }),
            textColors: ThemeDefault.buttonTextColorMainCta,
            textStyle: buttonTextStyle,
            borderColors: ThemeDefault.buttonTransparentColor,
        },
        buttonCircularOutlineBlack: {
            buttonColors: ThemeDefault.buttonTransparentColor,
            containerStyle: Object.assign({}, buttonContainerStyle, { paddingVertical: Token.spacing.xs - 1, paddingHorizontal: Token.spacing.s - 1, borderWidth: 1, borderRadius: 24 }),
            textColors: ThemeDefault.buttonTextOutlineBlack,
            textStyle: buttonTextStyle,
            borderColors: ThemeDefault.buttonBorderOutlineBlack,
        },
        buttonCircularOutlineWhite: {
            buttonColors: ThemeDefault.buttonTransparentColor,
            containerStyle: Object.assign({}, buttonContainerStyle, { paddingVertical: Token.spacing.xs - 1, paddingHorizontal: Token.spacing.s - 1, borderWidth: 1, borderRadius: 24 }),
            textColors: ThemeDefault.buttonTextOutlineWhite,
            textStyle: buttonTextStyle,
            borderColors: ThemeDefault.buttonBorderOutlineWhite,
        },
        buttonFloating: {
            buttonColors: {
                active: themeColor.lightPrimary,
                pressed: themeColor.lightPrimary,
                disabled: themeColor.lightNeutral,
            },
            containerStyle: Object.assign({}, buttonContainerStyle, PlatformStyle.elevation.hover, { borderRadius: 24 }),
            textColors: ThemeDefault.buttonTextColorSecondary,
            textStyle: buttonTextStyle,
            borderColors: ThemeDefault.buttonTransparentColor,
        },
    };
}
const typography = {
    // Variant
    hero: Object.assign({ fontSize: Token.fontSize.gigantic, lineHeight: 56 }, PlatformStyle.textWeightMediumStyle),
    display: Object.assign({ 
        // common usage: category title
        fontSize: Token.fontSize.huge, lineHeight: 40 }, PlatformStyle.textWeightMediumStyle),
    headline: Object.assign({ 
        // common usage: h1
        fontSize: Token.fontSize.big, lineHeight: 28 }, PlatformStyle.textWeightMediumStyle),
    title1: Object.assign({ 
        // common usage: h2, section title
        fontSize: Token.fontSize.large, lineHeight: 24 }, PlatformStyle.textWeightMediumStyle),
    title2: Object.assign({ 
        // common usage: h3, mobile navbar title, collapsible heading
        fontSize: Token.fontSize.medium, lineHeight: 20 }, PlatformStyle.textWeightMediumStyle),
    title3: Object.assign({ 
        // common usage: h4, input label
        fontSize: Token.fontSize.small, lineHeight: 16 }, PlatformStyle.textWeightMediumStyle),
    uiLarge: Object.assign({ 
        // common usage: paragraph deck, button large
        fontSize: Token.fontSize.large, lineHeight: 28 }, PlatformStyle.textWeightRegularStyle),
    uiBaseline: Object.assign({ 
        // common usage: paragraph, list,  cell text
        // common usage for component in normal size: input value/placeholder, tooltip text, snackbar message, button
        fontSize: Token.fontSize.medium, lineHeight: 24 }, PlatformStyle.textWeightRegularStyle),
    uiSmall: Object.assign({ 
        // common usage: paragraph small
        // common usage for component in small size: input value/placeholder, tooltip text, snackbar message, button
        fontSize: Token.fontSize.small, lineHeight: 20 }, PlatformStyle.textWeightRegularStyle),
    uiTiny: Object.assign({ 
        // common usage: mobile navbar subtitle, description cell text, breadcrumb, input helper & counter text (normal size input)
        fontSize: Token.fontSize.tiny, lineHeight: 16 }, PlatformStyle.textWeightRegularStyle),
    captionTiny: Object.assign({ fontSize: Token.fontSize.tiny, lineHeight: 12 }, PlatformStyle.textWeightRegularStyle),
    captionMicro: Object.assign({ 
        // bottom bar label
        fontSize: Token.fontSize.micro, lineHeight: 11 }, PlatformStyle.textWeightRegularStyle),
    // Misc
    weightRegular: PlatformStyle.textWeightRegularStyle,
    weightMedium: PlatformStyle.textWeightMediumStyle,
    weightBold: PlatformStyle.textWeightBoldStyle,
    fontSize: Token.fontSize,
};
export default {
    color: Object.assign({}, Token.color, ThemeDefault.color),
    typography,
    border: Token.border,
    spacing: Token.spacing,
    animation: Token.animation,
    elevation: PlatformStyle.elevation,
    opacity: Token.opacity,
    style: createStyles(),
};
